module.exports = __webpack_public_path__ + "media/images/admin/icons/tag-2365b9a69265a0777876ff557e5c20d8.svg";